import Heading from '@zenbusiness/zui/Heading';
import { styled } from '@zenbusiness/zui/styles';

const TitleStyles = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '32px!important',
    lineHeight: '40px!important'
  }
});

export const HeadingStyled = styled(Heading)(TitleStyles);
